<template>
  <div>
    <div class="credit-cards">
      <ul class="credit-cards__list">
        <!-- Cartão de credito -->
        <li
          class="credit-cards__list-item profile__card"
          v-for="card in creditCards"
          :key="card.id"
        >
          <div class="credit-cards__info">
            <img src="../assets/images/credit-card-icon.svg" />
            <div class="credit-cards__info-content">
              <span>{{ card.nickname }} (Cartão de crédito)</span>
              <h4>
                {{ card.brand }}
                <img src="../assets/images/meatball-icon-1.svg" />
                {{ card.last_four }}
              </h4>
            </div>
          </div>

          <div class="credit-cards__actions">
            <!-- <span class="credit-cards__maincard">Cartão principal</span> -->

            <div class="credit-cards__actions-button">
              <b-dropdown
                id="dropdown-right"
                right
                variant="none"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template #button-content>
                  <img src="../assets/images/meatball-icon-2.svg" />
                </template>
                <b-dropdown-item href="#">
                  Definir como principal
                </b-dropdown-item>
                <b-dropdown-item
                  id="changeCardButton"
                  href="#"
                  @click.prevent="changeCard(card)"
                >
                  Editar cartão
                </b-dropdown-item>
                <b-dropdown-item
                  id="deleteCardButton"
                  href="#"
                  @click.prevent="deleteCard(card)"
                >
                  Excluir cartão
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <BModal
      id="editCreditCard"
      ref="editCreditCard"
      hide-footer
      centered
      title="Editar cartão"
    >
      <div class="p-2">
        <div class="custom-form-control">
          <label>Apelido do cartão</label>
          <input
            class="form-control"
            :class="[
              !$v.selectedCreditCard.nickname.required
                ? 'form-control-invalid'
                : ''
            ]"
            type="text"
            v-model="selectedCreditCard.nickname"
          />
          <div class="error" v-if="!$v.selectedCreditCard.nickname.required">
            Campo obrigatório
          </div>
        </div>

        <button class="button1" @click.prevent="updateCreditCardNickname">
          Atualizar Cartão
        </button>
      </div>
    </BModal>
  </div>
</template>

<script>
import { userComputed, authComputed, userMethods } from "../state/helpers";
import { required } from "vuelidate/lib/validators";
import { formatDate } from "./../utils/masks/formatSlotDate";

export default {
  name: "CreditCardsTable",
  data() {
    return {
      selectedCreditCard: {},
      creditCards: []
    };
  },
  validations: {
    selectedCreditCard: {
      nickname: { required }
    }
  },
  async mounted() {
    await this.fetchCards();
  },
  methods: {
    ...userMethods,
    changeCard(credit_card) {
      let selectedCreditCard = Object.assign({}, credit_card);
      this.selectedCreditCard = selectedCreditCard;
      this.$bvModal.show("editCreditCard");
    },
    updateCreditCardNickname() {
      swal
        .fire({
          title: "Atualizar cartão?",
          icon: "info",
          showCancelButton: true
        })
        .then(result => {
          if (result.isConfirmed) {
            swal.showLoading();
            return this.updateUserCreditCard(this.selectedCreditCard)
              .then(() => {
                this.$bvModal.hide("editCreditCard");
                this.selectedCreditCard = {};
                swal.fire(
                  "Atualizado!",
                  "Cartão atualizado com sucesso.",
                  "success"
                );
              })
              .catch(() => {
                swal.fire(
                  "Opss!",
                  "Erro no servidor, tente mais tarde.",
                  "error"
                );
              });
          }
        });
    },
    deleteCard(credit_card) {
      if (this.creditCards.length == 1)
        return swal.fire(
          "Atenção!",
          "Você precisa ter ao menos um cartão cadastrado.",
          "warning"
        );

      swal.fire({
        title: "Deletar cartão?",
        text: "Essa ação não pode ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.deleteUserCreditCard(credit_card.id)
            .then(() => {
              this.removeDeletedCard(credit_card.id);
              swal.fire("Deletado!", "Cartão deletado com sucesso.", "success");
            })
            .catch(() => {
              swal.fire(
                "Opss!",
                "Erro no servidor, tente mais tarde.",
                "error"
              );
            });
        }
      });
    },
    async fetchCards() {
      await this.fetchUserCreditCards().then(response => {
        this.creditCards = response.data.filter(card => {
          card.flag = card.first_six;
          return card;
        });
      });
    },
    removeDeletedCard(credit_card_id) {
      this.creditCards = this.creditCards.filter(credit_card => {
        if (credit_card.id != credit_card_id) return credit_card;
      });
    },
    addCreditCard(credit_card) {
      this.creditCards.push({ ...credit_card, flag: credit_card.first_six });
    }
  },
  computed: {
    ...userComputed
  }
};
</script>
